import axios from "axios";
import {
  EXCHANGE_RATES, EXCHANGE_RATES_EXPORT_TEMPLATE, EXCHANGE_RATES_IMPORT_TEMPLATE, EXCHANGE_RATES_CURRENCIES
} from "@/services/ConstantService";
import {GlobalService} from "@/services/GlobalService";

export const ExchangeRateService = {
  async getExchangeRate(params) {
    return await axios.get(EXCHANGE_RATES, {params}).then(response => {
      return response.data ?? false
    }).catch(error => {
      GlobalService.handleError(error, 'GET EXCHANGE RATES LIST SERVICE')
      return false
    })
  },
  async downloadExchangeRateTemplate(params){
    return await axios.post(EXCHANGE_RATES_EXPORT_TEMPLATE, params,{
      responseType: 'blob'
    }).then(response => {
      return response.data ?? false
    }).catch(error => {
      GlobalService.handleError(error, 'EXPORT EXCHANGE RATE TEMPLATE SERVICE')
      return false
    })
  },
  async importExchangeRateTemplate(params) {
    try {
      const response = await GlobalService.ajax('post', EXCHANGE_RATES_IMPORT_TEMPLATE, params);
      return response.data ?? false;
    } catch (error) {
      return error;
    }
  },
  async getExchangeRatesCurrencies(params) {
    return await axios.get(EXCHANGE_RATES_CURRENCIES, {params}).then(response => {
      return response.data ?? false
    }).catch(error => {
      GlobalService.handleError(error, 'GET EXCHANGE RATES CURRENCIES LIST SERVICE')
      return false
    })
  },

  async createExchangeRateCurrency(data) {
    return await axios.post(EXCHANGE_RATES_CURRENCIES, data).then(response => {
      return response.data ?? false
    })
  },

  async updateExchangeRateCurrency(id, data) {
    return await axios.put(EXCHANGE_RATES_CURRENCIES + '/' + id, data).then(response => {
      return response.data ?? false
    })
  },

  async deleteExchangeRateCurrency(id, password) {
    return await axios.delete(EXCHANGE_RATES_CURRENCIES + '/' + id, { data: { password }}).then(response => {
      return response.data ?? false
    })
  },
}

export default { ExchangeRateService }
